var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-md-person",
    "data-name": "Icon ionic-md-person",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.058,
    height: 18.058,
    viewBox: "0 0 18.058 18.058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-person-2",
    "data-name": "Icon ionic-md-person",
    d: "M13.529,13.529A4.515,4.515,0,1,0,9.015,9.015,4.528,4.528,0,0,0,13.529,13.529Zm0,2.257C10.538,15.786,4.5,17.31,4.5,20.3v2.257H22.558V20.3C22.558,17.31,16.52,15.786,13.529,15.786Z",
    transform: "translate(-4.5 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.1a8a30347fb67f88bef78aa2ead99e25.svg";
export { ForwardRef as ReactComponent };